import React from "react";
import { Grid } from "@theme-ui/components";
import componentMapper from "./component-mapper";

const Group = ({ innerBlocks }) => {
  if (innerBlocks.length === 1 && Object.keys(innerBlocks[0]).length === 0) {
    return null;
  }
  return (
    <Grid
      sx={{ my: [4], breakBefore: "avoid", pageBreakInside: "avoid" }}
      gap={[4]}
      columns={[1, 2]}
    >
      {componentMapper(innerBlocks, true)}
    </Grid>
  );
};

export default Group;
